/** @type {import('../schema').ExperienceEntity[]} */
export const sxswLondonEntities = [
  {
    id: 'sxsw-london',
    slug: 'sxsw-london',
    entityType: 'venue',
    name: 'SXSW London',
    shortDescription: 'A city-wide festival of technology, film, music, business, and culture centered in Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.sxswlondon.com/',
  },
  {
    id: 'truman-brewery',
    slug: 'truman-brewery',
    entityType: 'venue',
    name: 'The Truman Brewery',
    shortDescription: 'The heart of the inaugural SXSW London campus and the anchor for the week.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'nobu-shoreditch',
    slug: 'nobu-london-shoreditch',
    entityType: 'hotel',
    name: 'Nobu Hotel London Shoreditch',
    shortDescription: 'A calm home base within walking distance of the conference venues.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://london-shoreditch.nobuhotels.com/',
  },
  {
    id: 'artotel-london-hoxton',
    slug: 'artotel-london-hoxton',
    entityType: 'hotel',
    name: 'art’otel London Hoxton',
    shortDescription: 'Marcus’s London home base during SXSW London 2025, close to the Shoreditch conference footprint.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'demis-hassabis-ai',
    slug: 'demis-hassabis-ai',
    entityType: 'session',
    name: 'The Future of Artificial Intelligence',
    shortDescription: 'An opening conversation with Demis Hassabis that set the tone for the week.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'idris-elba-creativity-session',
    slug: 'idris-elba-creativity-as-capital-for-change',
    entityType: 'session',
    name: 'Creativity as Capital for Change',
    shortDescription: 'The Idris Elba session that drew a queue stretching for multiple blocks through Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'village-underground',
    slug: 'village-underground',
    entityType: 'venue',
    name: 'Village Underground',
    shortDescription: 'A Shoreditch music venue where Henry Lau brought an international crowd together.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://villageunderground.co.uk/',
  },
  {
    id: 'curzon-hoxton',
    slug: 'curzon-hoxton',
    entityType: 'venue',
    name: 'Curzon Hoxton',
    shortDescription: 'An intimate cinema that hosted the Late Shift premiere and filmmaker Q&A.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.curzon.com/venues/hoxton/',
  },
  {
    id: 'barbican-centre',
    slug: 'barbican-centre',
    entityType: 'venue',
    name: 'Barbican Centre',
    shortDescription: 'The landmark arts center that hosted the Deep Cover premiere.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.barbican.org.uk/',
  },
  {
    id: 'the-ks-hoxton-hall',
    slug: 'the-ks-hoxton-hall',
    entityType: 'venue',
    name: 'The K’s at Hoxton Hall',
    shortDescription: 'A live set at Hoxton Hall between the Deep Cover premiere and the late night at XOYO.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'xoyo',
    slug: 'xoyo',
    entityType: 'venue',
    name: 'XOYO',
    shortDescription: 'A late-night club where Idris Elba closed out an unforgettable conference day.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://xoyo.co.uk/',
  },
  {
    id: 'old-street-records',
    slug: 'old-street-records',
    entityType: 'venue',
    name: 'Old Street Records',
    shortDescription: 'A record-store-inspired bar and live music venue near the center of the action.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.oldstreetrecords.com/',
  },
  {
    id: 'high-grade-coffee',
    slug: 'high-grade-coffee',
    entityType: 'restaurant',
    name: 'High Grade Coffee',
    shortDescription: 'The morning coffee stop that became part of the daily conference rhythm.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.highgrade.coffee/',
  },
  {
    id: 'owl-and-pussycat',
    slug: 'owl-and-pussycat',
    entityType: 'restaurant',
    name: 'Owl & Pussycat',
    shortDescription: 'A Shoreditch pub stop after the SXSW London opening party.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.owlandpussycatshoreditch.com/',
  },
  {
    id: 'shoreditch-fish-chips',
    slug: 'shoreditch-fish-and-chips',
    entityType: 'restaurant',
    name: 'Shoreditch Fish & Chips',
    shortDescription: 'A quick London classic between conference venues.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.shoreditchfishnchips.co.uk/',
  },
  {
    id: 'beigel-bake',
    slug: 'beigel-bake',
    entityType: 'restaurant',
    name: 'Beigel Bake',
    shortDescription: 'A famous Brick Lane stop for a fast, memorable late bite.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.beigelbake.co.uk/',
  },
  {
    id: 'queens-head',
    slug: 'queens-head',
    entityType: 'restaurant',
    name: "The Queen's Head",
    shortDescription: 'A historic pub stop woven naturally into the walk between venues.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://queensheadshoreditch.com/',
  },
  {
    id: 'george-and-vulture',
    slug: 'george-and-vulture',
    entityType: 'restaurant',
    name: 'George & Vulture',
    shortDescription: 'A centuries-old pub that gave the conference trip a sense of London history.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://georgeandvulture.com/',
  },
  {
    id: 'the-reliance',
    slug: 'the-reliance',
    entityType: 'restaurant',
    name: 'The Reliance',
    shortDescription: 'A relaxed pub for comparing notes between sessions.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://therelianceshoreditch.co.uk/',
  },
  {
    id: 'barley-mow',
    slug: 'barley-mow-shoreditch',
    entityType: 'restaurant',
    name: 'Barley Mow',
    shortDescription: 'A neighborhood pub stop during the Tuesday route through Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://thebarleymowshoreditch.co.uk/',
  },
  {
    id: 'bricklayers-arms',
    slug: 'bricklayers-arms-shoreditch',
    entityType: 'restaurant',
    name: 'Bricklayers Arms',
    shortDescription: 'A neighborhood pub stop during the Tuesday route through Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'old-blue-last',
    slug: 'old-blue-last',
    entityType: 'restaurant',
    name: 'The Old Blue Last',
    shortDescription: 'A storied Shoreditch pub and music landmark.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.theoldbluelast.com/',
  },
  {
    id: 'tower-bridge-walk',
    slug: 'tower-bridge-bermondsey-walk',
    entityType: 'activity',
    name: 'Tower Bridge to Bermondsey Beer Mile',
    shortDescription: 'A long city walk from the Tower of London, across Tower Bridge, and into Bermondsey.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'doodle-bar',
    slug: 'doodle-bar-bermondsey',
    entityType: 'restaurant',
    name: 'Doodle Bar',
    shortDescription: 'The first brewery stop on the walk along the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.thedoodlebar.com/',
  },
  {
    id: 'barrel-project',
    slug: 'barrel-project',
    entityType: 'restaurant',
    name: 'The Barrel Project',
    shortDescription: 'A brewery stop on the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.thebarrelproject.co.uk/',
  },
  {
    id: 'hiver-taproom',
    slug: 'hiver-taproom',
    entityType: 'restaurant',
    name: 'Hiver Taproom',
    shortDescription: 'A honey-beer taproom stop on the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://hiverbeers.com/pages/taproom',
  },
  {
    id: 'fabal-beerhall',
    slug: 'fabal-beerhall',
    entityType: 'restaurant',
    name: 'Fabal Beerhall',
    shortDescription: 'A colorful beer hall stop near the end of the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://hiverbeers.com/pages/fabal-beerhall',
  },
  {
    id: 'poulet-london',
    slug: 'poulet-london',
    entityType: 'restaurant',
    name: 'Poulet',
    shortDescription: 'A neighborhood restaurant that saved the night with one last chicken.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.poulet.biz/',
  },
  {
    id: 'the-culpeper',
    slug: 'the-culpeper',
    entityType: 'restaurant',
    name: 'The Culpeper',
    shortDescription: 'A pub and rooftop stop on the final walk back toward Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.theculpeper.com/',
  },
  {
    id: 'hunger-cure',
    slug: 'hunger-cure',
    entityType: 'restaurant',
    name: 'Hunger Cure',
    shortDescription: 'A final casual food stop that matched the spontaneous rhythm of the trip.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'dublin-side-quest',
    slug: 'dublin-side-quest',
    entityType: 'place',
    name: 'Dublin Side Quest',
    shortDescription: 'A quick Friday morning flight added one more city and one more country to the adventure.',
    city: 'Dublin',
    country: 'Ireland',
  },
  {
    id: 'hyatt-centric-dublin',
    slug: 'hyatt-centric-the-liberties-dublin',
    entityType: 'hotel',
    name: 'Hyatt Centric The Liberties Dublin',
    shortDescription: 'The Dublin home base for the bonus Friday side quest.',
    city: 'Dublin',
    country: 'Ireland',
  },
  {
    id: 'brazen-head-dublin',
    slug: 'brazen-head-dublin',
    entityType: 'restaurant',
    name: 'The Brazen Head',
    shortDescription: 'The first Dublin stop, reached immediately after dropping the bags at the hotel.',
    city: 'Dublin',
    country: 'Ireland',
    websiteUrl: 'https://brazenhead.com/',
  },
  {
    id: 'guinness-storehouse-tour',
    slug: 'guinness-storehouse-tour',
    entityType: 'activity',
    name: 'Guinness Storehouse Tour',
    shortDescription: 'A tour through the story, craft, and culture behind Guinness in Dublin.',
    city: 'Dublin',
    country: 'Ireland',
  },
  {
    id: 'temple-bar-dublin',
    slug: 'temple-bar-dublin',
    entityType: 'activity',
    name: 'The Temple Bar',
    shortDescription: 'A classic Dublin stop that carried the side quest into the evening.',
    city: 'Dublin',
    country: 'Ireland',
  },
];

export const sxswLondonEntityById = sxswLondonEntities.reduce((entities, entity) => ({
  ...entities,
  [entity.id]: entity,
}), {});
